<template>
    <div
        class="mt-2 flex w-full items-center justify-between gap-3 rounded-[6px] border border-red-100 bg-red-50 p-2.5"
    >
        <div class="flex min-w-0 items-center">
            <img :src="LETTR_LOGO" class="h-8 w-8 shrink-0" alt="" />

            <div class="ml-2 min-w-0 text-left">
                <div class="text-sm font-medium text-gray-700">Lettr</div>
                <div class="truncate text-sm text-gray-500">
                    {{ LETTR_TAGLINE }}
                </div>
            </div>
        </div>

        <AtomicButton
            color="yellow"
            size="sm"
            @click="connect('lettr_export_panel')"
        >
            Connect
        </AtomicButton>
    </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';

import useLettrPromo, {
    LETTR_LOGO,
    LETTR_TAGLINE,
} from '@/composables/useLettrPromo';

const { trackImpression, connect } = useLettrPromo();

onMounted(() => {
    trackImpression('lettr_export_panel');
});
</script>
